import React from "react";
import PropTypes from "prop-types";
//Material imports
import Typography from "@mui/material/Typography";
import makeStyles from "@mui/styles/makeStyles";
//Limitless imports
import { useTranslation } from "@limitless/common/hooks";
import Checkbox from "../form-elements/check-box/Checkbox";
export const useCheckboxSelectorStyles = makeStyles(theme => ({
  checkboxLabelRoot: {
    marginLeft: 0,
    marginRight: 0
  },
  valueContainer: {
    height: 52,
    minWidth: 95,
    border: theme.palette.border,
    display: "flex",
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: 4
  },
  solidBackground: {
    backgroundColor: theme.palette.background.paper
  },
  contained: {
    maxWidth: 130,
    justifyContent: "unset"
  },
  disabledText: {
    color: theme.palette.action.disabled
  }
}));
const CheckboxSelector = ({
  label = "",
  value,
  checked,
  valueContainerStyles = "",
  onChange,
  checkedLabel = "",
  disabled,
  background,
  name,
  variant,
  id
}) => {
  const {
    t
  } = useTranslation();
  const classes = useCheckboxSelectorStyles();
  let valueContainer = `${classes.valueContainer} ${valueContainerStyles}`;
  if (background === "white") {
    valueContainer = `${valueContainer} ${classes.solidBackground}`;
  }
  if (variant === "contained") {
    valueContainer = `${valueContainer} ${classes.contained}`;
  }
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Typography, {
    color: "textPrimary",
    variant: "body1",
    className: `${disabled ? classes.disabledText : ""}`
  }, t(label)), /*#__PURE__*/React.createElement("div", {
    className: valueContainer
  }, /*#__PURE__*/React.createElement(Checkbox, {
    name: name,
    value: value,
    checked: checked,
    label: checkedLabel,
    onChange: onChange,
    checkboxLabelRoot: classes.checkboxLabelRoot,
    disabled: disabled,
    id: id
  })));
};
export default CheckboxSelector;
CheckboxSelector.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  name: PropTypes.string,
  valueContainerStyles: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  checkedLabel: PropTypes.string,
  disabled: PropTypes.bool,
  background: PropTypes.string,
  variant: PropTypes.string,
  id: PropTypes.string
};